/**
 * Dev-only debug logger. Stripped from production builds.
 *
 * Usage:
 *   import { debugLog } from "../lib/debug";
 *   try { ... } catch (e) { debugLog("editor poll failed:", e?.message); }
 *
 * Why: console.debug in production exposes internal flow and clutters DevTools.
 * `process.env.NODE_ENV` is statically evaluated by webpack/CRA at build time,
 * so the entire call site is dead-code-eliminated in `yarn build`.
 */
export const debugLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};
